import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import React from 'react';

import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';

// this component is used to check if the user wants to switch to active for orders
// if an order is activated/deactivated, all children line items will also be activated/deactivated
export interface IProps extends IWithStylesProps {
  // opens the modal
  active: boolean;
  name: string;
  ID: number;
  // is the item currently active for dialog options
  currentlyActive: boolean;

  // calls the api from props
  activeModel: (modelID: number) => Promise<any>;
  // generally these will just close the modal
  onClose?: (modelID: number) => void;
  onError?: (modelID: number) => void;
  onActive?: (modelID: number) => void;
}

interface IState {
  updating: boolean;
}

export const ModelDialogActiveView = decorate(
  {
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IProps, IState> {
    state = {
      updating: false,
    };

    onClose = () => {
      if (this.props.onClose) {
        this.props.onClose(this.props.ID);
      }
    };

    onError = () => {
      if (this.props.onError) {
        this.props.onError(this.props.ID);
      }
      this.setState({
        updating: false,
      });
    };

    onChangeActive = () => {
      if (this.props.onActive) {
        this.props.onActive(this.props.ID);
      }
      if (this.props.onClose) {
        this.props.onClose(this.props.ID);
      }
      this.setState({
        updating: false,
      });
    };

    // calls the api from props
    changeActive = () => {
      this.setState(
        {
          updating: true,
        },
        () => {
          this.props.activeModel(this.props.ID).then(this.onChangeActive, this.onError);
        },
      );
    };

    render() {
      const { updating } = this.state;
      const { active, currentlyActive, name } = this.props;
      return (
        <Grid>
          <Dialog
            open={active}
            onClose={this.onClose}
            disableBackdropClick={updating}
            disableEscapeKeyDown={updating}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle>{`Switch Active Status on ${name}?`}</DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {`Switching active status to ${currentlyActive ? 'Inactive' : 'Active'} will ${
                  currentlyActive ? 'deactivate' : 'activate'
                } all Line Items under this Order.`}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onClose} color='primary' autoFocus disabled={updating}>
                Cancel
              </Button>
              <Button onClick={this.changeActive} disabled={updating}>
                {`Yes, change status to ${currentlyActive ? 'Inactive' : 'Active'}`}
                <span style={updating ? { opacity: 1 } : { opacity: 0 }}>
                  &nbsp;
                  <CircularProgress size={12} />
                </span>
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      );
    }
  },
);
